document.addEventListener('turbo:load', () => {
  const elements = document.querySelectorAll('.size-by-sibling');
  for(let i = 0; i < elements.length; i++){
    const sib = elements[i].previousElementSibling;
    if(sib && sib.offsetHeight > 0){
      elements[i].style.height = sib.offsetHeight + 'px';
    }
  }
})